import { Card, Bleed, Box, Divider, FormLayout, InlineStack, IndexTable, Layout, Page, SkeletonBodyText, SkeletonDisplayText, SkeletonTabs, SkeletonThumbnail, BlockStack, RadioButton, Listbox, TextField } from "@shopify/polaris";
import React from "react";
import './skeleton.css';

export const FullPageLoader = () => {
    return <>
        <Page>
            <BlockStack gap="600">
                <InlineStack gap="300" align="space-between">
                    <div className="Header__Title--Skeleton">
                        <BlockStack gap={"200"}>
                            <SkeletonDisplayText maxWidth="55%" size="extraLarge" />
                            <SkeletonBodyText lines={1} />
                        </BlockStack>
                    </div>
                    <div className="Header__Badge--Skeleton">
                        <SkeletonDisplayText size="small" />
                    </div>
                </InlineStack>
                <BlockStack gap="200">
                    <InlineStack gap="400" blockAlign="center">
                        <div className="Header__Text--Skeleton">
                            <SkeletonDisplayText size="small" />
                        </div>
                        <RadioButton
                            label={<div className="Custom__Radio--Skeleton"><SkeletonBodyText lines={1} /></div>}
                        />
                        <RadioButton
                            label={<div className="Custom__Radio--Skeleton"><SkeletonBodyText lines={1} /></div>}
                        />
                    </InlineStack>
                    <SkeletonBodyText lines={3} />
                </BlockStack>
                <BlockStack gap="400">
                    <Box minHeight="80px" background="bg-fill-disabled"></Box>
                    <Card>
                        <SkeletonTabs count={6} />
                    </Card>
                    <FulfilmentTypeSkeleton />
                    <ProductTitleSkeleton />
                    <DescriptionSkeleton />
                    <HandlingTimeSkeleton />
                    <PriceSkeleton />
                    <BusinessPriceSkeleton />
                    <InventorySkeleton />
                    <AmazonSkuSkeleton />
                    <BarCodeSkeleton />
                    <AmazonCategorySkeleton />
                    <JsonAttributeMappingSkeleton />
                    <ImageSkeleton />
                </BlockStack>
            </BlockStack>
        </Page>
    </>;
}
export const FulfilmentTypeSkeleton = () => {
    return (
        <Card>
            <Layout>
                <Layout.AnnotatedSection
                    title={<div className="Custom__Heading--Skeleton">
                        <SkeletonDisplayText size="small" />
                    </div>}
                    description={
                        <div className="mt-16">
                            <SkeletonBodyText lines={3} />
                        </div>
                    }
                >
                    <Card background="bg-surface-secondary">
                        <InlineStack gap="300">
                            <div className="Custom__Radio--SkeletonPara"><SkeletonBodyText lines={1} /></div>
                            <div className="Custom__Radio--SkeletonPara"><SkeletonBodyText lines={1} /></div>
                        </InlineStack>
                    </Card>
                </Layout.AnnotatedSection>
            </Layout>
        </Card>
    )
};

export const ProductTitleSkeleton = () => {
    return (
        <Card>
            <Layout>
                <Layout.AnnotatedSection
                    title={<div className="Custom__Heading--Skeleton">
                        <SkeletonDisplayText size="small" />
                    </div>}
                    description={
                        <div className="mt-16">
                            <SkeletonBodyText lines={3} />
                        </div>
                    }
                >
                    <Card background="bg-surface-secondary">
                        <BlockStack gap="400">
                            <InlineStack gap="300">
                                <div className="Custom__Radio--SkeletonPara"><SkeletonBodyText lines={1} /></div>
                                <div className="Custom__Radio--SkeletonPara"><SkeletonBodyText lines={1} /></div>
                            </InlineStack>
                            <BlockStack gap="200">
                                <SkeletonDisplayText maxWidth="100%" size="medium" />
                                <div style={{ maxWidth: '100px' }}>
                                    <SkeletonBodyText lines={1} />
                                </div>
                            </BlockStack>
                        </BlockStack>
                    </Card>
                </Layout.AnnotatedSection>
            </Layout>
        </Card>
    )
};

export const DescriptionSkeleton = () => {
    return (
        <Card>
            <Layout>
                <Layout.AnnotatedSection
                    title={<div className="Custom__Heading--Skeleton">
                        <SkeletonDisplayText size="small" />
                    </div>}
                    description={
                        <div className="mt-16">
                            <SkeletonBodyText lines={4} />
                        </div>
                    }
                >
                    <Card background="bg-surface-secondary">
                        <BlockStack gap="400">
                            <InlineStack gap="300">
                                <div className="Custom__Radio--SkeletonPara"><SkeletonBodyText lines={1} /></div>
                                <div className="Custom__Radio--SkeletonPara"><SkeletonBodyText lines={1} /></div>
                            </InlineStack>
                            <SkeletonDisplayText maxWidth="100%" size="extraLarge" />
                            <SkeletonBodyText lines={5} />
                            <SkeletonBodyText lines={5} />
                        </BlockStack>
                    </Card>
                </Layout.AnnotatedSection>
            </Layout>
        </Card>
    )
};

export const HandlingTimeSkeleton = () => {
    return (
        <Card>
            <Layout>
                <Layout.AnnotatedSection
                    title={<div className="Custom__Heading--Skeleton">
                        <SkeletonDisplayText size="small" />
                    </div>}
                    description={
                        <div className="mt-16">
                            <SkeletonBodyText lines={4} />
                        </div>
                    }
                >
                    <Card background="bg-surface-secondary">
                        <BlockStack gap="400">
                            <InlineStack gap="300">
                                <div className="Custom__Radio--SkeletonPara"><SkeletonBodyText lines={1} /></div>
                                <div className="Custom__Radio--SkeletonPara"><SkeletonBodyText lines={1} /></div>
                            </InlineStack>
                            <SkeletonDisplayText maxWidth="100%" size="medium" />
                            <SkeletonBodyText lines={3} />
                        </BlockStack>
                    </Card>
                </Layout.AnnotatedSection>
            </Layout>
        </Card>
    )
};

export const PriceSkeleton = () => {
    return (
        <Card>
            <Layout>
                <Layout.AnnotatedSection
                    title={<div className="Custom__Heading--Skeleton">
                        <SkeletonDisplayText size="small" />
                    </div>}
                    description={
                        <div className="mt-16">
                            <SkeletonBodyText lines={4} />
                        </div>
                    }>
                    <Card background="bg-surface-secondary">
                        <BlockStack gap="400">
                            <InlineStack gap="300">
                                <div className="Custom__Radio--SkeletonPara"><SkeletonBodyText lines={1} /></div>
                                <div className="Custom__Radio--SkeletonPara"><SkeletonBodyText lines={1} /></div>
                            </InlineStack>
                            <SkeletonDisplayText size="small" />
                        </BlockStack>
                    </Card>
                </Layout.AnnotatedSection>
            </Layout>
        </Card>
    )
};

export const BusinessPriceSkeleton = () => {
    return (
        <Card>
            <Layout>
                <Layout.AnnotatedSection
                    title={<div className="Custom__Heading--Skeleton">
                        <BlockStack gap={"300"}>
                            <SkeletonDisplayText size="small" />
                            <SkeletonBodyText lines={2} />
                        </BlockStack>
                    </div>}
                    description={
                        <div className="mt-16">
                            <SkeletonBodyText lines={4} />
                        </div>
                    }>
                    <Card background="bg-surface-secondary">
                        <BlockStack gap="400">
                            <InlineStack gap="300">
                                <div className="Custom__Radio--SkeletonPara"><SkeletonBodyText lines={1} /></div>
                                <div className="Custom__Radio--SkeletonPara"><SkeletonBodyText lines={1} /></div>
                            </InlineStack>
                        </BlockStack>
                    </Card>
                </Layout.AnnotatedSection>
            </Layout>
        </Card>
    )
};

export const InventorySkeleton = () => {
    return (
        <Card>
            <Layout>
                <Layout.AnnotatedSection
                    title={<div className="Custom__Heading--Skeleton">
                        <SkeletonDisplayText size="small" />
                    </div>}
                    description={
                        <div className="mt-16">
                            <SkeletonBodyText lines={3} />
                        </div>
                    }>
                    <Card background="bg-surface-secondary">
                        <BlockStack gap="400">
                            <BlockStack gap="300">
                                <div className="Custom__Heading--Skeleton">
                                    <SkeletonDisplayText size="small" />
                                </div>
                                <SkeletonBodyText lines={3} />
                            </BlockStack>
                            <div className="Custom__Radio--SkeletonPara"><SkeletonBodyText lines={1} /></div>
                            <div className="Custom__Radio--SkeletonPara"><SkeletonBodyText lines={1} /></div>
                        </BlockStack>
                    </Card>
                </Layout.AnnotatedSection>
            </Layout>
        </Card>
    )
};

export const AmazonSkuSkeleton = () => {
    return (
        <Card>
            <Layout>
                <Layout.AnnotatedSection
                    title={<div className="Custom__Heading--Skeleton">
                        <SkeletonDisplayText size="small" />
                    </div>}
                    description={
                        <div className="mt-16">
                            <SkeletonBodyText lines={4} />
                        </div>
                    }>
                    <Card background="bg-surface-secondary">
                        <BlockStack gap="400">
                            <InlineStack gap="300">
                                <div className="Custom__Radio--SkeletonPara"><SkeletonBodyText lines={1} /></div>
                                <div className="Custom__Radio--SkeletonPara"><SkeletonBodyText lines={1} /></div>
                            </InlineStack>
                            <SkeletonDisplayText maxWidth="100%" size="medium" />
                        </BlockStack>
                    </Card>
                </Layout.AnnotatedSection>
            </Layout>
        </Card>
    )
};

export const BarCodeSkeleton = () => {
    return (
        <Card>
            <Layout>
                <Layout.AnnotatedSection
                    title={<div className="Custom__Heading--Skeleton">
                        <SkeletonDisplayText size="small" />
                    </div>}
                    description={
                        <div className="mt-16">
                            <SkeletonBodyText lines={3} />
                        </div>
                    }>
                    <Card background="bg-surface-secondary">
                        <BlockStack gap="400">
                            <SkeletonBodyText lines={2} />
                            <InlineStack gap="300">
                                <div className="Custom__Radio--SkeletonPara"><SkeletonBodyText lines={1} /></div>
                                <div className="Custom__Radio--SkeletonPara"><SkeletonBodyText lines={1} /></div>
                            </InlineStack>
                            <SkeletonDisplayText maxWidth="100%" size="medium" />
                        </BlockStack>
                    </Card>
                </Layout.AnnotatedSection>
            </Layout>
        </Card>
    )
};

export const AmazonCategorySkeleton = () => {
    return (
        <Card>
            <Layout>
                <Layout.AnnotatedSection
                    title={<div className="Custom__Heading--Skeleton">
                        <SkeletonDisplayText size="small" />
                    </div>}
                    description={
                        <div className="mt-16">
                            <SkeletonBodyText lines={3} />
                        </div>
                    }>
                    <Card background="bg-surface-secondary">
                        <BlockStack gap="400">
                            <SkeletonDisplayText maxWidth="100%" size="medium" />
                            <InlineStack gap="300">
                                <div className="Custom__Radio--SkeletonPara"><SkeletonBodyText lines={1} /></div>
                                <div className="Custom__Radio--SkeletonPara"><SkeletonBodyText lines={1} /></div>
                            </InlineStack>
                            <SkeletonDisplayText maxWidth="100%" size="medium" />
                            <SkeletonBodyText lines={5} />
                        </BlockStack>
                    </Card>
                </Layout.AnnotatedSection>
            </Layout>
        </Card>
    )
};

export const JsonAttributeMappingSkeleton = () => {
    return (
        <Card>
            <BlockStack gap="500">
                <InlineStack gap="200" wrap={false}>
                    <div className="rounded-skeleton">
                        <SkeletonDisplayText />
                    </div>
                    <div style={{ width: '100%', maxWidth: '75%' }}>
                        <div className="Custom__Heading--Skeleton">
                            <SkeletonDisplayText size="small" />
                        </div>
                        <div className="mt-16">
                            <SkeletonBodyText lines={2} />
                        </div>
                    </div>
                </InlineStack>
                <SkeletonDisplayText maxWidth="100%" size="medium" />
                <Divider />
                <Layout>
                    <Layout.Section variant="oneThird">
                        <Listbox>
                            {
                                Array.from({ length: 5 }, (_, index) => (
                                    <Listbox.Option value="ProductIdentity" key={index}>
                                        <Listbox.TextOption>
                                            <div className='custom-listing_items Custom__Heading--Skeleton'>
                                                <SkeletonDisplayText maxWidth="100%" size="small" />
                                            </div>
                                        </Listbox.TextOption>
                                    </Listbox.Option>
                                ))
                            }
                        </Listbox>
                    </Layout.Section>
                    <Layout.Section>
                        <BlockStack gap="500">
                            <BlockStack gap="400">
                                <div style={{ width: '100%' }}>
                                    <div className="Custom__Heading--Skeleton">
                                        <SkeletonDisplayText size="small" />
                                    </div>
                                    <div className="mt-16">
                                        <SkeletonBodyText lines={2} />
                                    </div>
                                </div>
                                <Divider />
                                <BlockStack gap="300">
                                    <Card roundedAbove='xs'>
                                        <BlockStack gap="300">
                                            <div style={{ width: '100%' }}>
                                                <div className="Custom__Heading--Skeleton">
                                                    <SkeletonDisplayText size="small" />
                                                </div>
                                                <div className="mt-16">
                                                    <SkeletonBodyText lines={2} />
                                                </div>
                                            </div>
                                            <Divider />
                                            <InlineStack align='end'>
                                                <div className="Custom__Heading--Skeleton">
                                                    <SkeletonDisplayText size="small" />
                                                </div>
                                            </InlineStack>
                                        </BlockStack>
                                    </Card>
                                    <Card roundedAbove='xs'>
                                        <BlockStack gap="300">
                                            <div style={{ width: '100%' }}>
                                                <div className="Custom__Heading--Skeleton">
                                                    <SkeletonDisplayText size="small" />
                                                </div>
                                                <div className="mt-16">
                                                    <SkeletonBodyText lines={2} />
                                                </div>
                                            </div>
                                            <Divider />
                                            <InlineStack align='end'>
                                                <div className="Custom__Heading--Skeleton">
                                                    <SkeletonDisplayText size="small" />
                                                </div>
                                            </InlineStack>
                                        </BlockStack>
                                    </Card>
                                </BlockStack>
                            </BlockStack>
                            <div className="footer-skeleton">
                                <InlineStack gap="300" align='space-between' blockAlign='center'>
                                    <SkeletonDisplayText size="small" />
                                    <SkeletonDisplayText size="small" />
                                    <SkeletonDisplayText size="small" />
                                </InlineStack>
                            </div>
                        </BlockStack>
                    </Layout.Section>
                </Layout>
            </BlockStack>
        </Card>
    )
};

export const ImageSkeleton = () => {
    return (
        <Card>
            <Layout>
                <Layout.AnnotatedSection
                    title={<div className="Custom__Heading--Skeleton">
                        <SkeletonDisplayText size="small" />
                    </div>}
                    description={
                        <div className="mt-16">
                            <SkeletonBodyText lines={3} />
                        </div>
                    }
                >
                    <Card background="bg-surface-secondary">
                        <InlineStack gap="300">
                            <div className="Custom__Radio--SkeletonPara"><SkeletonBodyText lines={1} /></div>
                            <div className="Custom__Radio--SkeletonPara"><SkeletonBodyText lines={1} /></div>
                        </InlineStack>
                    </Card>
                </Layout.AnnotatedSection>
            </Layout>
        </Card>
    )
};

export function errorSkeleton() {
    return <>
        <Card>
            <BlockStack gap="500">
                <SkeletonDisplayText />
                <SkeletonTabs />
                <BlockStack gap="400">
                    <div className='label__skeleton'>
                        <SkeletonBodyText lines={1} />
                    </div>
                    <SkeletonBodyText lines={1} />
                </BlockStack>
                <Bleed marginInline="500"><Divider /></Bleed>
                <SkeletonBodyText lines={1} />
            </BlockStack>
        </Card>

    </>
};
export function quantitySelection() {
    return <>
        <Card roundedAbove='sm'>
            <BlockStack gap="200">
                <div className="Custom__Heading--Skeleton">
                    <SkeletonDisplayText size="small" />
                </div>
                <SkeletonBodyText lines={2} />
                <BlockStack gap="100">
                    <RadioButton
                        label={<div className="Custom__Radio--SkeletonPara"><SkeletonBodyText lines={2} /></div>}
                    />
                    <RadioButton
                        label={<div className="Custom__Radio--SkeletonPara"><SkeletonBodyText lines={1} /></div>}
                    />
                </BlockStack>
            </BlockStack>
        </Card>
    </>;
}
export function requiredAttributesskeleton() {
    return <>
        <Card roundedAbove='sm'>
            <FormLayout>
                <BlockStack gap="500">
                    <SkeletonDisplayText />
                    <div>
                        <SkeletonBodyText lines={2} />
                    </div>
                    <FormLayout>
                        <FormLayout.Group>
                            <BlockStack gap="200">
                                <div className='Tempalate_name--skeleton'>
                                    <SkeletonBodyText lines={1} />
                                </div>
                                <div className='textfield__skeleton'>
                                    <SkeletonDisplayText />
                                </div>
                            </BlockStack>
                            <BlockStack gap="200">
                                <div className='Tempalate_name--skeleton'>
                                    <SkeletonBodyText lines={1} />
                                </div>
                                <div className='textfield__skeleton'>
                                    <SkeletonDisplayText />
                                </div>
                            </BlockStack>
                            <BlockStack gap="200">
                                <div className='Tempalate_name--skeleton'>
                                    <SkeletonBodyText lines={1} />
                                </div>
                                <div className='textfield__skeleton'>
                                    <SkeletonDisplayText />
                                </div>
                            </BlockStack>
                        </FormLayout.Group>
                    </FormLayout>
                </BlockStack>
            </FormLayout>
        </Card>
    </>;
}
export function optionalattributeSkeleton() {
    return (
        <Card roundedAbove="sm">
            <BlockStack gap="400">
                <BlockStack gap="500">
                    <div className='skeleton--head'>
                        <SkeletonDisplayText />
                    </div>
                    <div className='skeleton--primarybutton'>
                        <SkeletonDisplayText />
                    </div>
                </BlockStack>
            </BlockStack>
        </Card>
    );
}
export function amazonParentSkuskeleton() {
    return <>
        <Card roundedAbove='sm'>
            <BlockStack gap="200">
                <div className="Custom__Heading--Skeleton">
                    <SkeletonDisplayText size="small" />
                </div>
                <SkeletonBodyText lines={2} />
                <BlockStack gap="100">
                    <RadioButton
                        label={<div className="Custom__Radio--SkeletonPara"><SkeletonBodyText lines={1} /></div>}
                    />
                    <div className="Custom__TextField--Skeleton">
                        <SkeletonDisplayText size="medium" />
                    </div>
                    <RadioButton
                        label={<div className="Custom__Radio--SkeletonPara"><SkeletonBodyText lines={1} /></div>}
                    />
                </BlockStack>
            </BlockStack>
        </Card>
    </>;
}
export function variantGridSkeleton(t: any) {
    function skeletonvariantHeadings(): any {
        return [{ title: t('Image'), id: 0 },
        { title: t('Variant Title'), id: 1 },
        { title: t('SKU'), id: 2 },
        { title: t('Status'), id: 3 },
        { title: t('Barcode'), id: 4 },
        { title: t('Price'), id: 5 },
        { title: t('Inventory'), id: 6 }];
    }
    const orders = [
        {
            id: '1020',
            image: <SkeletonThumbnail />,
            variant: <SkeletonBodyText lines={1} />,
            sku: <div className='sku'> <SkeletonBodyText lines={1} /></div>,
            status: <SkeletonBodyText lines={1} />,
            barcode: <SkeletonBodyText lines={1} />,
            price: <SkeletonBodyText lines={1} />,
            inventory: <SkeletonBodyText lines={1} />,
        },
        {
            id: '1021',
            image: <SkeletonThumbnail />,
            variant: <SkeletonBodyText lines={1} />,
            sku: <div className='sku'> <SkeletonBodyText lines={1} /></div>,
            status: <SkeletonBodyText lines={1} />,
            barcode: <SkeletonBodyText lines={1} />,
            price: <SkeletonBodyText lines={1} />,
            inventory: <SkeletonBodyText lines={1} />,
        },
        {
            id: '1022',
            image: <SkeletonThumbnail />,
            variant: <SkeletonBodyText lines={1} />,
            sku: <div className='sku'> <SkeletonBodyText lines={1} /></div>,
            status: <SkeletonBodyText lines={1} />,
            barcode: <SkeletonBodyText lines={1} />,
            price: <SkeletonBodyText lines={1} />,
            inventory: <SkeletonBodyText lines={1} />,
        },
        {
            id: '1023',
            image: <SkeletonThumbnail />,
            variant: <SkeletonBodyText lines={1} />,
            sku: <div className='sku'> <SkeletonBodyText lines={1} /></div>,
            status: <SkeletonBodyText lines={1} />,
            barcode: <SkeletonBodyText lines={1} />,
            price: <SkeletonBodyText lines={1} />,
            inventory: <SkeletonBodyText lines={1} />,
        },
    ];
    const rowMarkup = orders.map(
        (
            { id, image, variant, sku, status, barcode, price, inventory },
            index,
        ) => (
            <IndexTable.Row
                id={id}
                key={id}

                position={index}
            >
                <IndexTable.Cell>{image}</IndexTable.Cell>
                <IndexTable.Cell>{variant}</IndexTable.Cell>
                <IndexTable.Cell>{sku}</IndexTable.Cell>
                <IndexTable.Cell>{status}</IndexTable.Cell>
                <IndexTable.Cell>{barcode}</IndexTable.Cell>
                <IndexTable.Cell>{price}</IndexTable.Cell>
                <IndexTable.Cell>{inventory}</IndexTable.Cell>
            </IndexTable.Row>
        ),
    );
    return <Card>
        <BlockStack gap="400">
            <BlockStack gap="300">
                <div className='radio__skeleton'>
                    <SkeletonDisplayText size="small" />
                </div>
                <SkeletonBodyText lines={1} />
            </BlockStack>
            <Card padding={"0"}>
                <Box padding={"200"}>
                    <TextField label labelHidden disabled autoComplete="off" />
                </Box>
                <Divider borderColor='border-secondary' />
                <IndexTable
                    key={'IndexTableExample'}
                    itemCount={orders.length}
                    headings={skeletonvariantHeadings()}
                    selectable={false}
                >
                    {rowMarkup}
                </IndexTable>
            </Card>
        </BlockStack>
    </Card>
}

export function allCategories() {
    return <Box padding='400'>
        <FormLayout>
            <FormLayout.Group>
                <SkeletonDisplayText></SkeletonDisplayText>
                <SkeletonDisplayText></SkeletonDisplayText>
            </FormLayout.Group>
            <SkeletonBodyText lines={1} /><FormLayout.Group>
                <SkeletonDisplayText></SkeletonDisplayText>
                <SkeletonDisplayText></SkeletonDisplayText>
            </FormLayout.Group>
        </FormLayout>
    </Box>
}
